import React from 'react';
import PropTypes from 'prop-types';
import * as classes from './index.module.css'
import AnimatedGrid from '@components/AnimatedGrid'
import { data } from './data';

const Quote = ({text}) => {
    
    return (
        <>
        <div className={classes.root}>
            <div className={classes.imageContainer}>
                <AnimatedGrid
                    dCells={data?.dCells}
                    mCells={data?.mCells}
                    dCols={16}
                    dRows={6}
                    mCols={6}
                    mRows={10}
                />
            </div>
            <div className={classes.cont}>
                <div className={classes.contentContainer}>
                    <span className={classes.startQuote}>“</span>
                    <blockquote className={classes.titleContainer}>
                        {text}
                    </blockquote>
                </div>
            </div>
        </div>
        </>
    );
};

Quote.propTypes = {
    video: PropTypes.object,
    text: PropTypes.object
};

export default Quote;